module.exports = __webpack_public_path__ + "img/female-default.ac9102d8.svg";